import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Files } from './components/files';
import { filesPaths } from './filesPaths';

export const filesRoutes = [
  {
    path: `${filesPaths.root}/*`,
    element: <Files />,
    handle: {
      header: {
        titleKey: 'file.list.files',
        icon: 'file',
      },
      requiredPermission: Permissions.filespage.read,
    },
    children: [],
  },
];
